export const environment = {
    production: false,
    serverScheme: 'https://',
    serverDns: 'qa.medworldexpo.com',
    hostname: 'qa.medworldexpo.com',
    paymentBaseUrl: 'https://qa.medworldexpo.com',
    MASTERDATA_BASE_URL: '',
    ONBOARDING_BASE_URL: '',
    AUTH_BASE_URL: '',
    SEARCH_BASE_URL: '',
    WEBSOCKET_URL: 'https://qa.medworldexpo.com/onboarding/ws',
  };
  
environment.MASTERDATA_BASE_URL = `${environment.serverScheme}${environment.serverDns}/gw-mm/mdm/api/masterdata/`;
environment.ONBOARDING_BASE_URL = `${environment.serverScheme}${environment.serverDns}/gw-on/onboarding`;
environment.AUTH_BASE_URL = `${environment.serverScheme}${environment.serverDns}/gw-au/auth/api/user`;
environment.SEARCH_BASE_URL = `${environment.serverScheme}${environment.serverDns}/gw-sh/search`;
